import isEmpty from "lodash/isEmpty";
import { AUTHORIZATION_HEADER } from "../../constants/constants";
import isNil from "lodash/isNil";

const userKey = `oidc.user:${process.env.REACT_APP_AUTHORITY}:${process.env.REACT_APP_CLIENT_ID}`;

let userCache = null;
export const getCurrentUser = () => {
    if (isNil(userCache)) {
        let user = localStorage.getItem(userKey);
        if (isEmpty(user)) {
            user = sessionStorage.getItem(userKey);
            if (!isEmpty(user)) {
                localStorage.setItem(userKey, user);
            }
        }
        try {
            userCache = JSON.parse(user);
        } catch (e) {
            console.error('Unable to parse user information using: "' + user + '"');
            userCache = null;
        }
    }
    return userCache ?? { access_token: null, token_type: null };
};

const getPayload = (jwt) => {
    return atob(jwt.split(".")[1]);
}

export const getCurrentToken = () => {
    let token = localStorage.getItem("access_token");
    if (isEmpty(token)) {
        token = sessionStorage.getItem("access_token");
        if (!isEmpty(token)) {
            localStorage.setItem("access_token", token);
        }
    }
    return token;
};

export const saveToken = (token) => {
    localStorage.setItem("access_token", token);
    sessionStorage.setItem("access_token", token);
}

export const isExpired = (token) => {
    const payload = JSON.parse(getPayload(token));
    const expiration = new Date(0);
    expiration.setUTCSeconds(payload.exp);
    const now = new Date();
    if (now.getTime() > expiration.getTime()){
        return true;
    }

    return false;
}

export const authenticate = async (guid) => {
    try {
        const response = await fetch(process.env.REACT_APP_PASSENGER_DOCS_SEARCH + '/token/' + guid);
        const data = await response.json();
        return data.token;
    } catch (error) {
        console.error('Authentication error:', error);
        throw error;
    }
};

export const refresh = async (token) => {
    try{
        const options = {
            headers: new Headers({'X-BAGS-TOKEN': 'Bearer ' + token})
        }
        const response = await fetch(process.env.REACT_APP_PASSENGER_DOCS_SEARCH + '/token/refresh', options);
        const data = await response.json();
        return data.token;
    } catch (error) {
        console.error('Authentication error:', error);
        throw error;
    }
};
